import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch, shallowEqual} from 'react-redux';
import {ThemeProvider} from '@material-ui/styles';
import {makeStyles} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import './style.scss';
import Header from '&/components/layouts/Header';
import {MainDrawer, AlterDrawer, MobileDrawer} from '&/components/layouts/Drawers';
import ThemePicker from '&/components/layouts/ThemePicker';
import ScrollButton from '&/components/ScrollButton';
import PageLoader from '&/components/PageLoader';
import NotFound from '&/components/NotFound';
import AddToHomescreen from 'react-add-to-homescreen';
import {ChangeDrawer, Logout} from '&/utils/hotKeys';
import {logout} from '&/store/auth/actions';

const useStyles = makeStyles(theme => ({
	toolbar: theme.mixins.toolbar,
}));

const App = ({children}) => {
	const matches = useMediaQuery('(min-width:800px)');

	const classes = useStyles();

	const [themePicker, setThemePicker] = useState(true);
	const [alterDrawer, setAlterDrawer] = useState(false);
	const [mobileDrawer, setMobileDrawer] = useState(false);
	const [scrollButton, setScrollButton] = useState(false);

	const app = useSelector(state => state.app, shallowEqual);
	const auth = useSelector(state => state.auth, shallowEqual);
	const dispatch = useDispatch();

	useEffect(() => {
		const scrollUp = () => {
			if (window.scrollY > 400) {
				setScrollButton(true);
			} else setScrollButton(false);
		};

		window.addEventListener('scroll', scrollUp);

		return () => {
			window.removeEventListener('scroll', scrollUp);
		};
	}, []);

	const executeScrollUp = () => window.scrollTo({top: 0, behavior: 'smooth'});

	const openThemePicker = () => {
		setThemePicker(true);
	};

	const closeThemePicker = () => {
		setThemePicker(false);
	};

	const handleSearchChange = e => {};

	const handleChangeDrawer = () => {
		alterDrawer ? setAlterDrawer(false) : setAlterDrawer(true);
	};

	const openMobileDrawer = () => {
		setMobileDrawer(true);
	};

	const closeMobileDrawer = () => {
		setMobileDrawer(false);
	};
	const handleAddToHomescreenClick = () => {
		alert('1. Open Share menu'); // eslint-disable-line no-alert
	};

	return (
		<ThemeProvider theme={app.theme}>
			<AddToHomescreen onAddToHomescreenClick={handleAddToHomescreenClick} />
			<CssBaseline />

			<div id='root'>
				<ChangeDrawer action={handleChangeDrawer} />
				<Logout action={() => dispatch(logout())} />

				<Header
					auth={auth}
					openDrawer={matches ? handleChangeDrawer : openMobileDrawer}
					//handleSearchChange={handleSearchChange}
					openThemePicker={openThemePicker}
					logout={() => dispatch(logout())}
				/>
				<AddToHomescreen onAddToHomescreenClick={handleAddToHomescreenClick} />

				{matches && auth.isAuth ? (
					alterDrawer ? (
						<AlterDrawer auth={auth} />
					) : (
						<MainDrawer auth={auth} />
					)
				) : (
					<MobileDrawer open={mobileDrawer} auth={auth} closeDrawer={closeMobileDrawer} />
				)}

				<main className='content'>
					<div className={classes.toolbar} />

					{app.loading ? <PageLoader /> : app.notFound ? <NotFound /> : children}
				</main>

				<ScrollButton open={scrollButton} action={executeScrollUp} />

				<ThemePicker open={themePicker} theme={app.theme} closeModal={closeThemePicker} />
			</div>
		</ThemeProvider>
	);
};

export default App;
